const numeric = /^\d$/;

export default function mask( input ) {
  input.addEventListener( 'keydown', e => {
    if ( e.keyCode === 8 ) {
      const value = e.target.value;
      const start = e.target.selectionStart;
      const end   = e.target.selectionEnd;

      let selected;

      if ( start === end ) {
        selected = value.slice( start - 1, start );
      } else {
        selected = value.slice( start, end );
      }

      // special-case deletion of a single hyphen to remove the
      // previous digit
      if ( selected === '-' && selected.length === 1 ) {
        const first = e.target.value.slice( 0, start - 1 );
        const last  = e.target.value.slice( end );
        e.target.value = `${ first }${ last }`;
        e.target.setSelectionRange( first.length, first.length );
      }
    }
  });

  input.addEventListener( 'input', e => {
    const value  = e.target.value;
    const pos    = e.target.selectionEnd;

    let npa = '';
    let nxx = '';
    let ext = '';

    const numbers = value.split('').filter( s => numeric.test( s ) );

    npa = numbers.slice( 0, 3 ).join('');
    nxx = numbers.slice( 3, 6 ).join('');
    ext = numbers.slice( 6, 10 ).join('');

    let formatted = npa;

    if ( formatted.length >= 3 ) {
      formatted += '-';
    }

    formatted += nxx;

    if ( formatted.length >= 7 ) {
      formatted += '-';
    }

    formatted += ext;

    e.target.value = formatted;

    if ( pos !== value.length ) {
      e.target.setSelectionRange( pos, pos );
    }
  });
}
